export type BuildUrlParamsConfig = {
  append?: string;
  urlEncode?: boolean;
};

export const buildUrlParams = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parameters: Record<string, any>,
  config: BuildUrlParamsConfig = {}
): string => {
  const {append = '', urlEncode = false} = config;
  const ret: string[] = [];

  Object.keys(parameters).forEach((key) => {
    const val = parameters[key];
    let stringifiedVal: string;
    if (typeof val === 'string') {
      stringifiedVal = `"${val}"`;
    } else if (Array.isArray(val)) {
      stringifiedVal = JSON.stringify(val);
    } else {
      stringifiedVal = `${val}`;
    }
    ret.push(
      `${append}${key}=${
        urlEncode ? encodeURIComponent(stringifiedVal) : stringifiedVal
      }`
    );
  });

  return ret.join('&');
};
